import * as historyActions from "../actions/audio-video-history";
import { InmateAccountPayment } from '../models/InmateAccountPayment';
import { IPaginatedResponse } from '../services/api';

export interface IAudioVideoPaymentHistoryState {
  loading: boolean,
  error?: Error,
  history?: IPaginatedResponse<InmateAccountPayment>
}

const initialState:IAudioVideoPaymentHistoryState = {
  loading: false
};

export function audioVideoPaymentHistoryReducer(state: IAudioVideoPaymentHistoryState = initialState, action): IAudioVideoPaymentHistoryState {
  switch (action.type) {
    case historyActions.LOADING:
      return {
        ...state,
        loading: true,
        error: undefined
      };

    case historyActions.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case historyActions.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        history: action.history
      };
  }

  return state;
}
